// paymentsApi.js — Stripe-Checkout client for members.
// Small shared client so Tournament / RR / Club Event Pay buttons all go
// through the same route.
import axios from 'axios';

const client = axios.create({
  baseURL: `${process.env.REACT_APP_BACKEND_URL}/api`,
  headers: { 'Content-Type': 'application/json' },
});
client.interceptors.request.use((cfg) => {
  const token = typeof window !== 'undefined' ? localStorage.getItem('tl_session_token') : null;
  if (token) cfg.headers.Authorization = `Bearer ${token}`;
  return cfg;
});

export const paymentsAPI = {
  // Create (or reuse) a Stripe Checkout Session.
  // Body: { event_kind, event_id }
  // Returns: { url, session_id, reused }
  createCheckout: ({ eventKind, eventId }) =>
    client.post('/payments/checkout', { event_kind: eventKind, event_id: eventId }),

  // Poll the status endpoint after returning from Stripe. Owner or admin only.
  getSession: (sessionId) => client.get(`/payments/session/${sessionId}`),
};
